import { useEffect, useRef, useState } from 'react';
import { Divider } from '@mui/material';
import { CitCrowdsaleWidget } from 'widgets/cit-crowdsale-widget/ui';

import { tableOfContents } from './constants';
import { TokenCitContent, TokenCitHero, TokenCitStats } from './ui';

export const TokenCit = () => {
  const [activeSection, setActiveSection] = useState<string>(tableOfContents[0].id);
  const sections = useRef<NodeListOf<HTMLElement>>();

  useEffect(() => {
    const handleScroll = () => {
      const pageYScroll = window.scrollY;
      let currentActiveSection: string | null = null;

      sections.current?.forEach((section) => {
        const sectionOffsetTop = section.offsetTop - 10;
        const sectionHeight = section.offsetHeight;

        if (pageYScroll >= sectionOffsetTop && pageYScroll < sectionOffsetTop + sectionHeight + 98) {
          currentActiveSection = section.id;
        }
      });

      if (currentActiveSection) {
        setActiveSection(currentActiveSection);
      }
    };

    sections.current = document.querySelectorAll('[data-section]');
    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <TokenCitHero />
      <CitCrowdsaleWidget />
      <TokenCitStats />
      <TokenCitContent activeSection={activeSection} />
      <Divider flexItem sx={{ mt: 5.5, mb: { xs: 6, md: 12 }, mx: { xs: -2.5, lg: 'calc((1300px - 100vw) / 2 )' } }} />
    </>
  );
};
